<template>
    <div fluid class="mb-4 background-container admin-home">
      <b-row>
        <div class="collections-selection background-container">
          <div class="container background-container">
            <div class="collections-list pl-2 pr-0 mt-3 mb-3">
              <div
                v-for="tab in ['Board', 'Backlog']"
                :key="tab"
                class="media user-item px-0"
                :class="{ 'selected-collection': tab.toLocaleLowerCase() === selectedTab }"
                @click="selectTab(tab)"
              >
                <div
                  class="media user-item px-0"
                >
                  <div class="avatar mr-3 d-flex pl-3 muted-text">
                    <i v-if="tab === 'Board'" class="ri-terminal-window-line" style="font-size: 16px"></i>
                    <i v-else-if="tab === 'Backlog'" class="ri-stack-line" style="font-size: 16px"></i>
                  </div>
                  <div class="d-flex flex-column text-left pr-3 collection-info">
                    <h6 class="mb-0">{{ tab }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="database-screen background-container">
          <router-view></router-view>
        </div>
      </b-row>
    </div>
</template>

<script>
import { xray } from '../../../config/pluginInit'
import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'BugsManagementMenu',
  mounted () {
    xray.index()
  },
  setup (props, context) {
    const selectedTab = ref(null)
    const route = useRoute()
    const router = useRouter()

    onMounted(() => {
      selectedTab.value = route.path.split('/').pop()
    })

    watch(route, () => {
      selectedTab.value = route.path.split('/').pop()
    })

    const selectTab = (tab) => {
      switch (tab) {
        case 'Board':
          router.push({ name: 'admin.bugBoard' })
          break
        case 'Backlog':
          router.push({ name: 'admin.bugBacklog' })
          break
      }
    }

    return {
      selectedTab,
      selectTab
    }
  }
}
</script>

<style scoped>
  .admin-home {
    padding: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  .collections-selection {
    width: 15%;
    border-right: 1px solid var(--border-color);
    border-radius: 4px 0 0 4px !important;
  }

  .database-screen {
    width: 85%;
  }

  .icon-large {
    font-size: 3rem;
  }

  .container {
    background-color: white;
    font-size: 0.9rem;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 7px 0 0 7px !important;
  }

  .collections-list {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .search-input {
    height: 30px;
  }

  .search-icon {
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
  }

  .user-item {
    cursor: pointer;
    color: grey;
    align-items: center;
    padding: 5px 0;
  }

  .user-item.selected-collection {
    color: black;
    background-color: var(--light-grey);
    border-radius: 7px;
    width: 100%;
  }

  .text-left {
    text-align: left;
  }

  .collection-info {
    flex: 1;
    min-width: 0;
    font-size: 14px;
  }
</style>
